import e from "./index895.js";
var t = typeof self == "object" && self && self.Object === Object && self, r = e || t || Function("return this")();
export {
  r as default
};
